import accessDeniedImg from '@assets/status-pages/access_denied.webp';
import { useLingui } from '@lingui/react/macro';
import StatusPage from '@routes/system/___shared___/components/status-page';
import { Text } from '@routes/system/___shared___/components/status-page/styled.tsx';

const NotAuthorized = () => {
    const { t } = useLingui();

    return (
        <StatusPage
            image={<img src={accessDeniedImg} alt={t`access denied`} />}
            header={'403'}
            subheader={t`Access Denied!`}
            content={<Text>{t`You don’t have permission to access this page.`}</Text>}
        />
    );
};

export default NotAuthorized;
